import { useState, useEffect, useCallback } from "react";
import { CalendarCheck, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { BookingFlow } from "@/pages/BookPage";
import { fmtSlot } from "@/components/booking/SlotPicker";

export const BookCallCard = ({ onBooked }) => {
  const [mine, setMine] = useState(null);
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get("/api/booking/mine").then(r => setMine(r.data)).catch(() => setMine([])), []);
  useEffect(() => { load(); }, [load]);
  const cancel = async (b) => {
    if (!window.confirm("Cancel this onboarding call?")) return;
    try { const { data } = await api.post(`/api/booking/${b.id}/cancel`); toast.success(data.message); load(); onBooked?.(); } catch { toast.error("Couldn't cancel"); }
  };
  if (!mine) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm mb-4" data-testid="book-call-card">
      <div className="flex flex-wrap items-center gap-2">
        <CalendarCheck className="w-5 h-5 text-blue-600" /><h3 className="font-semibold text-slate-900 flex-1">Onboarding call</h3>
        {!mine.length && <button onClick={() => setOpen(!open)} className={`px-4 py-2 rounded-lg text-sm font-bold ${open ? "bg-slate-100 text-slate-700" : "bg-blue-600 text-white hover:bg-blue-500"}`} data-testid="book-call-toggle">{open ? "Close" : "Book a time"}</button>}
      </div>
      {mine.map(b => (
        <div key={b.id} className="mt-3 flex flex-wrap items-center gap-3 bg-blue-50 border border-blue-100 rounded-lg p-3" data-testid={`my-booking-${b.id}`}>
          <p className="text-sm text-slate-800 flex-1">Booked for <b>{fmtSlot(b.start_at)}</b> · {b.minutes} min — it's listed under Your meetings.</p>
          <button onClick={() => cancel(b)} className="text-sm text-red-600 font-semibold flex items-center gap-1" data-testid={`cancel-booking-${b.id}`}><X className="w-4 h-4" />Cancel</button>
        </div>
      ))}
      {!mine.length && !open && <p className="text-sm text-slate-500 mt-1">Pick a time for a 30-minute video call with our team to set up your shop.</p>}
      {open && !mine.length && <div className="mt-4"><BookingFlow onBooked={() => { load(); onBooked?.(); }} /></div>}
    </div>
  );
};
